<template>
  <d-data-table
    resource="users"
    detailed
    searchable
    fluid
  >
    <b-table-column
      v-slot="props"
      field="name"
      :label="$t('attributes.name').capitalize()"
      sortable
    >
      <div class="is-flex is-align-items-center">
        <img
          :src="props.row.avatar_url"
          :alt="props.row.name"
          width="28"
          class="is-rounded-full mr-2 is-avatar"
        >
        <div>
          <p>
            {{ props.row.name }}
          </p>
          <p
            v-if="$mq == 'tablet' || $mq == 'desktop' || $mq == 'widescreen'"
            class="is-size-7 has-text-grey"
          >
            {{ props.row.email }}
          </p>
        </div>
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="email"
      :label="$t('attributes.email').capitalize()"
      sortable
      :visible="$mq == 'mobile' || $mq == 'fullhd'"
    >
      <div class="is-size-7">
        {{ props.row.email }}
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="role"
      :label="$t('admin').capitalize()"
      sortable
    >
      <d-bool-icon
        :true-value="true"
        :false-value="false"
        :value="props.row.role == 'admin'"
      />
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="role"
      :label="$t('employee').capitalize()"
      sortable
    >
      <d-bool-icon
        :true-value="true"
        :false-value="false"
        :value="props.row.role == 'employee'"
      />
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="role"
      :label="$t('owner').capitalize()"
      sortable
    >
      <d-bool-icon
        :true-value="true"
        :false-value="false"
        :value="props.row.role == 'client' && props.row.owner_id !== null"
      />
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="role"
      :label="$t('owner_contact').capitalize()"
      sortable
    >
      <d-bool-icon
        :true-value="true"
        :false-value="false"
        :value="props.row.role == 'client' && props.row.owner_id == null"
      />
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="updated_at"
      :visible="$mq == 'mobile' || $mq == 'widescreen' || $mq == 'fullhd'"
      :label="$t('activity')"
      sortable
    >
      <div>
        <p class="is-size-7 has-text-grey">
          {{ $t("attributes.updated_at").capitalize() }}
        </p>
        <p class="is-size-7">
          {{ $dayjs(props.row.updated_at).format("LLL") }}
        </p>
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="terms_and_conditions_accepted_at"
      :label="$t('terms_and_conditions_accepted_at')"
      sortable
    >
      <p
        v-if="props.row.terms_and_conditions_accepted_at"
        class="is-size-7"
      >
        {{ $dayjs(props.row.terms_and_conditions_accepted_at).format("LL") }}
      </p>
    </b-table-column>

    <template #actions="props">
      <a
        v-if="props.row.role === 'employee'"
        type="button"
        class="button is-small is-white"
        :href="publicAgentUrl(props.row)"
        target="_blank"
        :title="$t('see_agent_listings')"
      >
        <div class="icon has-text-grey">
          <i class="mdi mdi-home-search-outline mdi-18px" />
        </div>
      </a>
      <a
        v-if="props.row.can.impersonate"
        type="button"
        class="button is-small is-white"
        :href="$laravel.route('impersonate', props.row.id)"
      >
        <div class="icon has-text-grey">
          <i class="mdi mdi-login-variant mdi-18px" />
        </div>
      </a>
    </template>

    <template #detail="props">
      <p class="is-size-7">
        <b>{{ $t("attributes.created_at").capitalize() }}</b>: {{ $dayjs(props.row.created_at).format("LLL") }}
      </p>
    </template>
  </d-data-table>
</template>

<script>
export default {
  methods: {
    publicAgentUrl(user) {
      const slug = (user.name || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

      return "/public?agent=" + slug;
    },
  },
};
</script>

<style lang="scss" scoped>
.is-avatar {
  border-radius: 50% !important;
  width: 28px;
  height: 28px;
}
</style>
